__webpack_require__.p = "/flashcards-generator/";